import BaseModal from "./BaseModal/BaseModal";
import ScoreProgress from "../component/ScoreProgress";
import SentenceCefr from "../../Tools/CrfChecker/Components/SentenceCefr";
import AnswerDropDown from "../component/AnswerDropDown";
import ScoreProgressCard from "../component/ScoreProgressCard";
import {useState} from "react";

export default function SpeakAboutThePhotoModal({className,showModal,setShowModal,result, ...props}) {


    let response = result;


    return (
        <BaseModal
            title={"AI Score"}
            isBoxOpen={showModal}
            setIsBoxOpen={setShowModal}
        >

            <div className={"flex flex-col lg:px-12 gap-8"}>
                <div>
                    <h1 className={"text-2xl font-bold text-center text-gray-700 mb-10 "}>Score: {result?.overAllScore}/160 </h1>
                    <div
                        className={"flex flex-row lg:w-[70%] mx-auto flex-wrap gap-[30px] lg:gap-[60px] justify-center items-center my-4  lg:px-10"}>
                        <ScoreProgress value={result?.overAllScore}
                                       total={160}
                                       color={"#0C99FF"}
                                       title={"Overall Score"}/>
                        <ScoreProgress value={result?.grammaticalAccuracy}
                                       total={160}
                                       color={"#00B828"}
                                       title={"Grammatical accuracy"}/>
                        <ScoreProgress value={result?.grammaticalComplexity}
                                       total={160}
                                       color={"#03EFFE"}
                                       title={"Grammatical complexity"}/>
                        <ScoreProgress value={result?.lexicalSophistication}
                                       total={160}
                                       color={"#FE0303"}
                                       title={"Lexical sophistication"}/>
                        <ScoreProgress value={result?.relevancy}
                                       total={160}
                                       color={"#FEF403"}
                                       title={"Task relevance"}/>
                        <ScoreProgress value={result?.fluency}
                                       total={160}
                                       color={"#50C0FF"}
                                       title={"Fluency"}/>
                        <ScoreProgress value={result?.lexicalDiversity}
                                       total={160}
                                       color={"#D250FF"}
                                       title={"Lexical diversity"}/>

                    </div>
                    <div className={"grid pt-12 grid-cols-1 lg:grid-cols-3 gap-8"}>
                        <ScoreProgressCard value={response?.grammaticalAccuracy}
                                           total={response?.totalScore || 160}
                                           color={"#00B828"}
                                           title={"Grammatical accuracy"}
                                           suggestions={response?.grammaticalAccuracySuggestions || []}
                        />
                        <ScoreProgressCard value={response?.grammaticalComplexity}
                                           total={response?.totalScore || 160}
                                           color={"#03EFFE"}
                                           title={"Grammatical complexity"}
                                           suggestions={response?.grammaticalComplexitySuggestions || []}
                        />
                        <ScoreProgressCard value={response?.lexicalSophistication}
                                           total={response?.totalScore || 160}
                                           color={"#FE0303"}
                                           suggestions={response?.lexicalSophisticationSuggestions || []}
                                           title={"Lexical sophistication"} />
                        <ScoreProgressCard value={response?.lexicalDiversity}
                                           suggestions={response?.lexicalDiversitySuggestions || []}
                                           total={response?.totalScore || 160}
                                           color={"#D250FF"}
                                           title={"Lexical diversity"} />
                        <ScoreProgressCard value={response?.relevancy}
                                           total={response?.totalScore || 160}
                                           color={"#6703fe"}
                                           suggestions={response?.relevancySuggestions || []}
                                           title={"Task relevance"} />

                    </div>

                </div>
                <div className={"w-full border-b-[1px] opacity-10 my-2 border-black"}/>

                <div className={"flex flex-col gap-3 "}>
                    <h1 className={"text-xl font-bold  text-gray-700  "}>AI Assessment </h1>
                    <p className={"text-sm font-normal  text-gray-700  "}>
                        {result?.aiRemarks}
                    </p>

                </div>



                <h1 className={"text-xl font-bold  text-gray-700  "}>CEFR Level
                </h1>
                <SentenceCefr

                    data={result?.cefrLevel?.occurance}
                    sentence={result?.cefrLevel?.sequence}

                />


            </div>
        </BaseModal>

    )
}